import React from 'react';

const SvgTwitter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
    <path d="M17.99 3.746a7.383 7.383 0 01-2.124.571 3.673 3.673 0 001.62-2.031 7.265 7.265 0 01-2.34.89 3.676 3.676 0 00-2.693-1.164 3.685 3.685 0 00-3.687 3.686c0 .286.035.571.091.845a10.48 10.48 0 01-7.602-3.858 3.658 3.658 0 00-.501 1.86c0 1.279.65 2.409 1.643 3.071a3.721 3.721 0 01-1.666-.468v.046a3.687 3.687 0 002.956 3.618c-.308.08-.64.125-.97.125-.24 0-.468-.022-.696-.057a3.693 3.693 0 003.447 2.557A7.384 7.384 0 01.89 15.012c-.308 0-.593-.011-.89-.045a10.418 10.418 0 005.661 1.655c6.78 0 10.49-5.616 10.49-10.49 0-.16 0-.32-.011-.48a7.923 7.923 0 001.85-1.906z" />
  </svg>
);

export default SvgTwitter;
